/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Rendra Pramulia
*/

import React, { useState, useEffect, useRef } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import Input from './Input';
import { isWeb } from '@global/screens';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaTable from '@components/sociolla/SociollaTable';
import ModalFull from '@components/modal/ModalFull';
import FormOverlay from '@components/form/common/FormOverlay';
import FormArrow from '@components/form/common/FormArrow';
import { getAttibutes, isVn } from '@global/helpers';
import { getProductsFromEs, getProductsCountFromEs } from '@api/ms-b2b';
import { getProductCount, getProducts } from '@api/ms-catalog';
import tableApi from '@/hooks/tableApi';
import Colors from '@global/colors';
import { INPUT_HEIGHT } from '@/constants';
import PropTypes from 'prop-types';

const propTypes = {
  labelKey: PropTypes.string,
  trackBy: PropTypes.string,
  hideLabel: PropTypes.bool,
  editable: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

const defaultProps = {
  value: '',
  labelKey: '',
  trackBy: '',
  hideLabel: false,
  editable: true,
};

const HEADER_DEKSTOP = [
  {
    label: 'Product Image',
    data: 'image',
    type: 'image',
    width: '15%',
    styleItem: {
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
  },
  {
    label: 'Internal Reference',
    data: 'reference',
    width: '25%',
    numberOfLines: 2,
  },
  {
    label: 'Name',
    data: 'name',
    width: '25%',
    numberOfLines: 3,
  },
  {
    label: 'Attribute Value',
    data: 'attributes',
    width: '35%',
    numberOfLines: 2,
  },
];

const defaultPhoto = require('@/assets/img/default/user-default.png');

const SelectProduct = (props) => {
  const {
    value = '',
    labelKey = '',
    trackBy = '',
    hideLabel = false,
    editable = true,
  } = props;

  const tableRef = useRef();

  const [showSelectProduct, setShowSelectProduct] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [emptyLabel, setEmptyLabel] = useState('Please search any product.');

  const [paramsTable, setParamsTable] = useState({
    filter: {},
    limit: isWeb ? 10 : 15,
    skip: 0,
  });
  const [list, setList] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);

  const products = tableApi(
    getProductCount,
    getProducts,
    getProductsCountFromEs,
    getProductsFromEs,
  );

  useEffect(() => {
    const newOptionsValue =
      props.options && props.options.length ? props.options : [];
    if (value) {
      const tempValue = checkValue(value, labelKey);
      const check = newOptionsValue.find(
        (c) => tempValue == checkValue(c, trackBy),
      );
      if (check) {
        setInputValue(check);
      } else {
        setInputValue(tempValue);
      }
    }
  }, [props]);

  // useEffect(() => {
  //     if (showSelectProduct === true) {
  //         products.request(paramsTable).then(response => {
  //             if (response) {
  //                 setList(generateData(response))
  //             }
  //         })
  //     }
  // }, [showSelectProduct]);

  const checkValue = (value, key) =>
    typeof value == 'object' && key ? value[key] : value;

  const callBackRowPress = (item) => {
    props.onChange(item.item);
    setShowSelectProduct(false);
  };

  const onSearchTable = async (param, type) => {
    const params = { ...paramsTable };
    if (type === 'keyword') {
      if (param.keyword.length > 2) {
        params.filter['keyword'] = param.keyword;
      } else if (!param.keyword) {
        delete params.filter['keyword'];
        setEmptyLabel('Please search any product.');
        setList([]);
        return;
      }
    } else if (type === 'pagination') {
      setLoadingMore(true);
      params.limit = param.limit;
      params.skip = param.skip;
    }
    await setParamsTable({ ...params });
    apiProduct(params);
  };

  const apiProduct = (params = null) => {
    const param = params ? params : { ...paramsTable };
    const hasFilter = Object.keys(param?.filter || {}).length ? true : false;
    products.request(param, null, hasFilter).then((response) => {
      if (response) {
        if (!response.length) {
          setEmptyLabel('No data found.');
        }
        if (param.skip > 0) {
          if (isWeb) {
            setList(generateData(response));
          } else {
            setList([...list, ...generateData(response)]);
          }
        } else {
          setList(generateData(response));
        }
        setLoadingMore(false);
      }
    });
  };

  const getImage = (image) => {
    let img = '';
    if (image?.length) {
      for (let index = 0; index < image.length; index++) {
        if (index === 0) {
          img = image[index].url;
        }
        if (image[index].is_cover) {
          img = image[index].url;
        }
      }
    }
    return img;
  };

  const generateData = (data) => {
    const products = [];
    for (let index = 0; index < data.length; index++) {
      const prod = data[index];
      for (let index2 = 0; index2 < prod.combinations.length; index2++) {
        const prodCombi = prod.combinations[index2];
        const combi = { name: prod.name };
        combi.reference = prodCombi.reference || '';
        combi.id = prod.id;
        combi.image = getImage(prodCombi.images);
        combi.attributes = getAttibutes(prodCombi.attributes);
        combi.product_combination_id = prodCombi._id;
        combi.ref_name = '[' + combi.reference + '] ' + combi.name;
        combi.category = prod.default_category;
        combi.ean_no = prodCombi.ean_no || '';
        combi.brand = prod.brand;
        combi.raw_attributes = prodCombi.attributes;
        if (
          isVn() ? prodCombi.is_active_in_b2b_vn : prodCombi.is_active_in_b2b
        ) {
          products.push(combi);
        }
      }
    }
    return products;
  };

  const renderItem = ({ item, index }) => (
    <TouchableOpacity
      onPress={() => callBackRowPress({ item })}
      key={'list-product-' + index}
      style={styles.tableRow}>
      <View style={styles.productItem}>
        <View style={{ width: '20%' }}>
          <Image
            source={{ uri: `${item.image ? item.image : defaultPhoto}` }}
            style={{ width: 36, height: 36 }}
            width={36}
            height={36}
            defaultSource={defaultPhoto}
          />
        </View>
        <View style={{ width: '80%' }}>
          <SociollaText
            type="medium"
            style={styles.productName}
            numberOfLines={1}>
            {item.name}
          </SociollaText>
          <SociollaText style={styles.productReference}>
            {item.reference}
          </SociollaText>
          <SociollaText
            type="medium"
            style={styles.productPrice}
            currency={true}>
            {item.price}
          </SociollaText>
        </View>
      </View>
    </TouchableOpacity>
  );

  const formValue = checkValue(inputValue, labelKey);

  return (
    <>
      <View style={{ position: 'relative' }}>
        <FormOverlay
          {...props}
          onCallback={() =>
            editable ? setShowSelectProduct(!showSelectProduct) : false
          }
        />
        <Input
          {...props}
          label={hideLabel ? '' : props.label}
          inputContainerStyle={{ height: INPUT_HEIGHT }}
          value={formValue}
          rightIcon={<FormArrow {...props} />}
          disabled={!editable}
        />
      </View>
      <ModalFull
        title={props.label}
        show={showSelectProduct}
        onClose={() => setShowSelectProduct(false)}
        width={isWeb ? 1000 : '100%'}>
        <View style={styles.tableContainer}>
          {isWeb && (
            <SociollaTable
              table={HEADER_DEKSTOP}
              ref={tableRef}
              datas={list}
              showSearch={true}
              searchBorder={true}
              scrollItem={true}
              maxHeight={320}
              stickyHeaderIndices={[0]}
              searchPlaceholder="Search by Name, SKU or Brands"
              emptyLabel={emptyLabel}
              count={products.count}
              showPagination
              loading={products.loading}
              loadingLoadMore={loadingMore}
              callBackRowPress={callBackRowPress}
              onSearchTable={(val, type) => onSearchTable(val, type)}
              localParams={paramsTable}
            />
          )}
          {!isWeb && (
            <SociollaTable
              datas={list}
              itemComponent={renderItem}
              headerComponent={<></>}
              showSearch={true}
              loading={products.loading}
              count={products.count}
              scrollItem={true}
              loadingLoadMore={loadingMore}
              searchPlaceholder="Search by Name, SKU or Brands"
              onSearchTable={(val, type) => onSearchTable(val, type)}
              localParams={paramsTable}
            />
          )}
        </View>
      </ModalFull>
    </>
  );
};

const styles = StyleSheet.create({
  tableRow: {
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    height: 90,
    width: '100%',
    flex: 1,
    borderBottomColor: Colors.grey9,
    borderBottomWidth: 1,
    paddingHorizontal: 20,
  },
  tableContainer: isWeb
    ? {
        backgroundColor: Colors.grey11,
        paddingHorizontal: 35,
        paddingVertical: 20,
      }
    : { flex: 1, backgroundColor: Colors.white },
  productItem: { flexDirection: 'row', width: '100%', alignItems: 'center' },
  productName: { fontSize: 14, color: Colors.black1, paddingBottom: 8 },
  productReference: { fontSize: 12, color: Colors.black5, paddingBottom: 9 },
  productPrice: { fontSize: 14, color: Colors.black1 },
});

SelectProduct.propTypes = propTypes;
SelectProduct.defaultProps = defaultProps;

export default React.memo(SelectProduct, (prev, next) => prev == next);
